import { Box, Paper } from "@mui/material";
import { withFraction32 } from "@/utils/fraction";
import { SawRunningProduct } from "../models/types";
import {
	CardBodySx,
	CardPaperSx,
	CardTitle,
	InfoGrid,
	InlineStats,
} from "./primitives";

type Props = {
	data?: SawRunningProduct | null;
};

const fpm = (v: number | null | undefined): string | null =>
	v != null ? `${v} fpm` : null;

// Judges the last cut against the tolerance window; undefined until all three arrive.
const lastCutStatus = (
	data: SawRunningProduct | null,
): "ok" | "bad" | undefined => {
	if (
		data?.lengthOfLastCut == null ||
		data.minLength == null ||
		data.maxLength == null
	)
		return undefined;
	return data.lengthOfLastCut >= data.minLength &&
		data.lengthOfLastCut <= data.maxLength
		? "ok"
		: "bad";
};

// "Live Cut Data" — the cut as the saw reports it: the tolerance window with
// the last cut judged against it, then blade speeds and the measured length.
export const LiveCutDataCard = ({ data = null }: Props) => (
	<Paper elevation={1} sx={CardPaperSx}>
		<CardTitle title="Live Cut Data" />

		<Box sx={CardBodySx}>
			<InlineStats
				items={[
					{ label: "Min", value: data?.minLength },
					{
						label: "Target",
						value: data?.targetBeamLength,
						highlight: true,
						pill: lastCutStatus(data),
					},
					{ label: "Max", value: data?.maxLength },
				]}
			/>

			<InfoGrid
				columns={1}
				items={[
					{ label: "Blade Speed Schd", value: fpm(data?.bladeSpeedSchdFpm) },
					{ label: "Blade Speed Cut", value: fpm(data?.bladeSpeedCutFpm) },
					{ label: "Cuts per Bundle", value: data?.cutsPerBundle ?? null },
					{
						label: "Last Shuttle Length",
						value:
							data?.lengthOfLastCut != null
								? withFraction32(data.lengthOfLastCut)
								: null,
					},
				]}
			/>
		</Box>
	</Paper>
);
